import axios from "axios";
import { useEffect, useState } from "react";
import FileInput from "../../HelperComponents/FileInput";
import "../../../css/SARAdmin.css"

export default function SAR_Admin({ CurrentUser }) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isModifying, setModifying] = useState(false);
    const [years, setYears] = useState({});
    const [currentYear, setCurrentYear] = useState(0);
    const [students, setStudents] = useState([]);
    const [studentsFile, setStudentsFile] = useState(null);
    const fileTypes = ["XLSX"];
    const [errors, setErrors] = useState({});

    useEffect(() => {
        initializePage();
    }, []);

    async function initializePage() {
        await getYears();
        if(!isLoaded) {
            await getCurrentYear();
            setIsLoaded(true);
        }
        setModifying(false);
    }

    function db2dt(db) {
        if(db === null) return {date: "", time: ""};
        let dt = new Date(db);
        dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset()); //Deployment
        //dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset()); //Local
        return date2dt(dt);
    }
    function dt2db({date, time}) {
        console.log(`{date: ${date}, time:${time}}`);
        if(date === "") //If missing day set the whole thing to blank
            return null;
        let dt = null;
        if(time === "") //If missing time set to midnight
            dt = new Date(`${date} 00:00:00`);
        else
            dt = new Date(`${date} ${time}:00`)
        //No deployment
        //dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset()); //Local
        let d = date2dt(dt);
        return `${d.date} ${d.time}`;
    }

    function date2dt(d) {
        let month = String(d.getMonth()+1).padStart(2,'0');
        let day = String(d.getDate()).padStart(2,'0');
        let date = `${d.getFullYear()}-${month}-${day}`;

        let hour = String(d.getHours()).padStart(2,'0');
        let minute = String(d.getMinutes()).padStart(2,'0');
        let time = `${hour}:${minute}`;
        return {date, time};
    }

    async function getYears() {
        return new Promise((resolve, reject) => {
            axios.get(
                "/api/sar/years"
            ).then((response) => {
                setYears(Object.fromEntries(
                    response.data.years.map(y => {
                        return [
                            y.year, {
                                studentOpen: db2dt(y.studentOpen),
                                studentClose: db2dt(y.studentClose),
                                facultyOpen: db2dt(y.facultyOpen),
                                facultyClose: db2dt(y.facultyClose),
                                gph: db2dt(y.gph),
                                touched: false,
                            }
                        ]
                    })
                ));
                return resolve();
            }).catch((error) => {
                if(error.response) {
                    console.error(`Error getting years: `, error.response);
                } else if(error.request) {
                    console.error(`Got no response to request: `, error.request);
                } else {
                    console.error(`Error: `, error)
                }
                alert(`Error getting years, \nContact an Admin if this persists.`);
                setYears([]);
                return resolve();
            });
        });
    }

    async function getCurrentYear() {
        return new Promise((resolve, reject) => {
            axios.get("/api/sar/year").then((response) => {
                if(response.data.year === null)
                    setCurrentYear(0);
                else
                    setCurrentYear(response.data.year.year);
                return resolve();
            }).catch((error) => {
                if(error.response) {
                    console.error(`Error getting open year: `, error.response);
                } else if(error.request) {
                    console.error(`Got no response to request: `, error.request);
                } else {
                    console.error(`Error: `, error)
                }
                alert(`Error getting current year, \nContact an Admin if this persists.`);
                setCurrentYear(0);
                return resolve();
            });
        });
    };

    function joinDT({date, time}) {
        console.log(`{date: ${date}, time:${time}}`);
        if(date === "") //If missing day set the whole thing to blank
            return null;
        else if(time === "") //If missing time set to midnight
            return `${date} 00:00:00`
        else
            return `${date} ${time}:00`
    }

    function addYear() {
        setModifying(true);
        let newYear = window.prompt("Please enter the year you would like to add.");
        if(isNaN(newYear) || parseInt(newYear) < 2000) {
            alert(`${newYear} is an invalid year, please try again.`);
            return;
        }
        axios.post(
            `/api/sar/years`, {year: newYear}
        ).then((response) => {
            return initializePage();
        }).catch((error) => {
            if (error.response) {
                console.error('Error adding year:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message)
            }
            alert(`Error adding year, \nContact an admin if this persists.`);
            return initializePage();
        })
    }

    function modifyYear() {
        setModifying(true);
        console.log(`Modifying ${currentYear}`);
        //join the date and time fields
        let y = {
            studentOpen: dt2db(years[currentYear].studentOpen),
            studentClose: dt2db(years[currentYear].studentClose),
            facultyOpen: dt2db(years[currentYear].facultyOpen),
            facultyClose: dt2db(years[currentYear].facultyClose),
            gph: dt2db(years[currentYear].gph),
        };
        axios.post(
            `/api/sar/years/${currentYear}`, y
        ).then((response) => {
            return initializePage();
        }).catch((error) => {
            if (error.response) {
                console.error('Error modifying year:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message)
            }
            alert(`Error modifying year, \nContact an admin if this persists.`);
            return initializePage();
        });
    }

    function deleteYear() {
        setModifying(true);
        axios.delete(
            `/api/sar/years/${currentYear}`
        ).then((response) => {
            return initializePage();
        }).catch((error) => {
            if (error.response) {
                console.error('Error deleting year:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message)
            }
            alert(`Error deleting year, \nContact an admin if this persists.`);
            return initializePage();
        });
    }

    function handleChange(event) {
        const {name, value} = event.target;
        let [year, field, part] = name.split("."); //Need to check if nested
        year = parseInt(year);
        setYears({
            ...years,
            [year]: {
                ...years[year],
                [field]: {
                    ...years[year][field],
                    [part]: value
                },
                touched: true
            }
        })
    }

    function getStudents() {
        return new Promise((resolve, reject) => {
            axios.get(
                `/api/sar/years/${currentYear}/students`
            ).then((response) => {
                if(response.data?.students) {
                    setStudents(response.data.students);
                    return resolve();
                } else
                    throw new Error();
            }).catch((error) => {
                if(error.response) {
                    console.error(`Error getting students for ${currentYear}: `, error.response);
                } else if(error.request) {
                    console.error(`Got no response to request: `, error.request);
                } else {
                    console.error(`Error: `, error)
                }
                alert(`Error getting students, \nContact an Admin if this persists.`);
                setStudents([]);
                return resolve();
            }).finally(() => setModifying(false));
        })
    }

    function handleStudentsFileChange(files) {
        if (files && files.length > 0) {
            const selectedFile = files[0];
            const fileExtension = selectedFile.name.split('.').pop().toUpperCase();

            if (!fileTypes.includes(fileExtension)) {
                alert("File uploaded was not XLSX!");
                return;
            }

            setStudentsFile(selectedFile);
        } else {
            setStudentsFile(null);
            alert('No file selected');
        }
    };
    function importStudents() {
        if(!studentsFile) {
            alert("Please upload a students excel file");
            return;
        }
        setModifying(true);
        const formData = new FormData();
        formData.append("files", studentsFile ?? {});
        axios.post(
            `/api/sar/years/${currentYear}/students`,
            formData
        ).then(() => {
            alert("Successfully imported students");
            setStudentsFile(null);
            getStudents();
        }).catch((error) => {
            const errorMessage = error.response?.data?.message;
            console.log(errorMessage);

            if (errorMessage.includes("Cannot read properties of undefined (reading 'map')")) {
                alert(`Incomplete Student List`);
            } else {
                alert(`Error while processing the file`);
            }

            setModifying(false);
            setStudentsFile(null);
            setModifying(false);
        })
    }
    function onTypeError(err) {
        alert("Invalid file type. Please upload an .xlsx (Excel) file.");
        setStudentsFile(null);
    }
    function onSizeError(file) {
        alert(`File size error for ${file.name}.`, 'error');
        setStudentsFile(null);
    }

    function deleteSAR(pid) {
        setModifying(true);
        axios.delete(
            `/api/sar/${currentYear}/${pid}`
        ).then(() => {
            alert("Successfully deleted student's SAR");
            getStudents();
        }).catch((error) =>{
            const errorMessage = error.response?.data?.message;
            if(!!errorMessage) {
                console.log(errorMessage);
                alert(errorMessage);
            } else {
                alert("Error occured while deleting student's SAR, \nContact an admin if this persists.");
            }
        })
    }

    useEffect(() => {
        if(isLoaded) {
            if(currentYear === 0) setStudents([]);
            else getStudents();
        }
    }, [currentYear]);

    useEffect(() => {
        if(currentYear !== 0)
            validateYear();
    }, [years]);

    function validateYear() {
        let year = years[currentYear];
        let studentOpen = joinDT(year.studentOpen);
        let studentClose = joinDT(year.studentClose);
        let facultyOpen = joinDT(year.facultyOpen);
        let facultyClose = joinDT(year.facultyClose);
        let gph = joinDT(year.gph);
        let e = {};
        if(
            studentOpen !== null && studentClose !== null &&
            new Date(studentOpen) >= new Date(studentClose)
        ) {
            e.student = "Open cannot be after Close";
        }
        if(
            facultyOpen !== null && facultyClose !== null &&
            new Date(facultyOpen) >= new Date(facultyClose)
        ) {
            e.faculty = "Open cannot be after Close";
        }
        setErrors(e);
    }

    if(!isLoaded) return(
        <div className="page-body">
            <h1>Loading SAR Admin...</h1>
        </div>
    );
    return(
        <div className="page-body">
            <div style={{display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <h1>SAR Admin</h1>
                <div className="top-buttons">
                    <div>
                        <label
                            className="form-label"
                            htmlFor="yearSelect"
                        >View Year:</label>
                        <select
                            id="yearSelect"
                            name="yearSelect"
                            className="form-select"
                            onChange={(event) => {
                                setCurrentYear(parseInt(event.target.value));
                            }}
                            value={currentYear}
                        >
                            <option value={0}></option>
                            {Object.keys(years).sort((a,b) => b - a).map((y) =>
                                <option value={y} key={y}>{y}</option>
                            )}
                        </select>
                    </div>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={addYear}
                        disabled={isModifying}
                    >Add Year</button>
                    {CurrentUser.pid === "bbradner" &&
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => console.log(years)}
                        >Info</button>
                    }
                </div>
            </div>
            {currentYear in years ?
                <form disabled={isModifying}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Student Dates</th>
                                <th>Faculty Dates</th>
                                <th>Green Thursday</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <label>Open</label>
                                    <div className="input-group date-time-wrapper">
                                        <input
                                            type="date"
                                            className="form-control"
                                            id={`${currentYear}.studentOpen.date`}
                                            name={`${currentYear}.studentOpen.date`}
                                            value={years[currentYear].studentOpen.date}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="time"
                                            className="form-control"
                                            id={`${currentYear}.studentOpen.time`}
                                            name={`${currentYear}.studentOpen.time`}
                                            value={years[currentYear].studentOpen.time}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <label>Close</label>
                                    <div className="input-group date-time-wrapper">
                                        <input
                                            type="date"
                                            className="form-control"
                                            id={`${currentYear}.studentClose.date`}
                                            name={`${currentYear}.studentClose.date`}
                                            value={years[currentYear].studentClose.date}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="time"
                                            className="form-control"
                                            id={`${currentYear}.studentClose.time`}
                                            name={`${currentYear}.studentClose.time`}
                                            value={years[currentYear].studentClose.time}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <strong>{errors.student}</strong>
                                </td>
                                <td>
                                    <label>Open</label>
                                    <div className="input-group date-time-wrapper">
                                        <input
                                            type="date"
                                            className="form-control"
                                            id={`${currentYear}.facultyOpen.date`}
                                            name={`${currentYear}.facultyOpen.date`}
                                            value={years[currentYear].facultyOpen.date}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="time"
                                            className="form-control"
                                            id={`${currentYear}.facultyOpen.time`}
                                            name={`${currentYear}.facultyOpen.time`}
                                            value={years[currentYear].facultyOpen.time}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <label>Close</label>
                                    <div className="input-group date-time-wrapper">
                                        <input
                                            type="date"
                                            className="form-control"
                                            id={`${currentYear}.facultyClose.date`}
                                            name={`${currentYear}.facultyClose.date`}
                                            value={years[currentYear].facultyClose.date}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="time"
                                            className="form-control"
                                            id={`${currentYear}.facultyClose.time`}
                                            name={`${currentYear}.facultyClose.time`}
                                            value={years[currentYear].facultyClose.time}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <strong>{errors.faculty}</strong>
                                </td>
                                <td>
                                    <label>Green Thursday</label>
                                    <div className="input-group date-time-wrapper">
                                        <input
                                            type="date"
                                            className="form-control"
                                            id={`${currentYear}.gph.date`}
                                            name={`${currentYear}.gph.date`}
                                            value={years[currentYear].gph.date}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="time"
                                            className="form-control"
                                            id={`${currentYear}.gph.time`}
                                            name={`${currentYear}.gph.time`}
                                            value={years[currentYear].gph.time}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </td>
                                <td>
                                    {CurrentUser.pid === "bbradner" &&
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => console.log(years[currentYear])}
                                        >Info</button>
                                    }
                                    <button
                                        type="button"
                                        className="btn btn-warning"
                                        disabled={!years[currentYear].touched || Object.keys(errors).length > 0}
                                        onClick={modifyYear}
                                    >Modify</button>
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={deleteYear}
                                    >Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h2>Students</h2>
                    {students.length > 0 &&  <table className="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>PID</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {students.map((s) => <tr key={s.studentPID}>
                                <td>{s.studentName}</td>
                                <td>{s.studentPID}</td>
                                <td>{
                                    s.sarStatus === 0 ? "Untouched" :
                                    s.sarStatus === 1 ? "Unsubmitted" :
                                    "Submitted"
                                }</td>
                                <td>
                                    {s.sarStatus === 0 ?
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => deleteSAR(s.studentPID)}
                                        >Delete</button>
                                    :
                                        <a
                                            href={`/sar/review/${currentYear}/${s.studentPID}`}
                                            target="_blank"
                                            className="btn btn-primary"
                                        >View</a>
                                    }
                                </td>
                            </tr>)}
                        </tbody>
                    </table>}
                    <div style={{display: "flex", alignItems:"center", paddingLeft:"2em"}}>
                        <h3 style={{paddingRight:"1em"}}>Import a student file:</h3>
                        <FileInput
                            file={studentsFile}
                            fileTypes={fileTypes}
                            handleChange={handleStudentsFileChange}
                            onSizeError={onSizeError}
                            onTypeError={onTypeError}
                            clearFile={() => {
                                setStudentsFile(null);
                            }}
                        />
                        <button type="button" className="btn btn-primary" onClick={importStudents} disabled={!studentsFile}>Import</button>
                    </div>
                </form>  
            :<h3>Please select a year</h3>}
        </div>
    );
}